import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';

export default function CustomTooltip({ title }) {
  return (
    <Tooltip enterTouchDelay={0} title={title} placement="bottom" arrow>
      <InfoIcon
        fontSize="10"
        sx={{ ml: 1, cursor: 'pointer', opacity: 0.56 }}
      />
    </Tooltip>
  );
}
